import MyUser from './user.vue'

const User = {
  install: function (Vue) {
    Vue.component('User', MyUser)
  }
}
export default User

/**
 * 自定义用户选择
 *  <User v-model="form.baseInfo.bussinessUser" :disabled="disable" dict="business_user"></User>
 */
